module.exports = __webpack_public_path__ + "static/cart2-6e85243dbd58eeacd6a9a5b35ecf6da8.svg";